export const contactTemplateSkeletonStyles = {
  wrapper: {
    pt: {
      tablet: "4.5rem",
    },
    margin: "auto",
    maxWidth: {
      laptop: "90vw",
      desktop: "69.438rem",
    },
    height: {
      mobile: "47.75rem",
      tablet: "44.4375rem",
    },
  },
  container: {
    display: "flex",
    flexDirection: {
      mobile: "column",
      laptop: "row",
    },
    margin: {
      mobile: "4.5rem, 1.5rem",
    },
    alignItems: "center",
    justifyContent: {
      mobile: "center",
      laptop: "space-between",
    },
  },
  title: {
    width: {
      mobile: "40vw",
      laptop: "15rem",
    },
    height: "1.25rem",
    mb: "1.5rem",
  },
  textContainer: {
    my: "1.875rem",
  },
  text: {
    width: {
      mobile: "80vw",
      tablet: "50vw",
      laptop: "27.8125rem",
    },
    height: "1.25rem",
  },
  formContainer: {
    height: {
      mobile: "18.1875rem",
    },
    alignItems: {
      mobile: "center",
      tablet: "end",
    },
    my: "3rem",
  },
  form: {
    width: {
      mobile: "70vw",
      laptop: "23.75rem",
    },
    height: {
      mobile: "2.25rem",
    },
  },
  formButton: {
    width: "9.5rem",
    height: "3.5rem",
  },
};
